import * as z from "zod";

export const createOrderTrackingViewFolder = {
  name: "createOrderTrackingViewFolder" as const,
  input: z.object({ name: z.string() }),
  output: z.object({ folderId: z.string() }),
};
